import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useAvailableProducts } from '@/store/dataStore';
import HScroll from '@/components/HScroll';
import { thumb } from '@/lib/img';

export default function CollectionsStrip() {
  const { products } = useAvailableProducts();
  const collections = useMemo(() => {
    const map = new Map();
    products.forEach((p) => { if (p.collection && p.collection.trim()) { const k = p.collection.trim(); if (!map.has(k)) map.set(k, p); } });
    return Array.from(map.entries()).map(([name, sample]) => ({ name, image: sample.image }));
  }, [products]);
  if (collections.length === 0) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 py-8">
      <div className="flex items-end justify-between mb-4">
        <h2 className="text-2xl md:text-3xl font-extrabold text-[#1B2A4A] flex items-center gap-2"><Sparkles className="text-yellow-500" /> Explora nuestras Colecciones</h2>
        <Link to="/catalogo" className="text-sm font-semibold text-[#1B2A4A] hover:text-yellow-600 underline">Ver todos</Link>
      </div>
      <HScroll testid="collections-strip">
        {collections.map((c) => (
          <Link key={c.name} to={`/catalogo?col=${encodeURIComponent(c.name)}`} data-testid={`collection-card-${c.name}`} className="group snap-start shrink-0 w-[42%] sm:w-[30%] md:w-[23%] lg:w-[18.5%] relative aspect-[4/5] rounded-2xl overflow-hidden shadow hover:shadow-xl transition-shadow">
            <img src={thumb(c.image, 400)} alt={c.name} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1B2A4A] via-[#1B2A4A]/40 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3 text-white">
              <div className="text-[10px] uppercase tracking-widest text-yellow-300 font-bold">Colección</div>
              <div className="font-extrabold text-lg leading-tight">{c.name}</div>
            </div>
          </Link>
        ))}
      </HScroll>
    </section>
  );
}
